import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";

import { getTitleForPath } from "../../services/PageTitle";

const TitleManager = () => {
  const location = useLocation();

  return (
    <Helmet>
      <title>{getTitleForPath(location.pathname)}</title>
    </Helmet>
  );
};

export default TitleManager;
